{
  "version": 1,
  "asset_id": "7b0e9f44-9ece-4c8c-9dec-0841c4dd8a02",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7b0e9f44-9ece-4c8c-9dec-0841c4dd8a02/hiatal-type-2-sleeve-en-1448.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7b0e9f44-9ece-4c8c-9dec-0841c4dd8a02/hiatal-type-2-sleeve-en-1448.webp",
  "original_filename": "hiatal-type-2-sleeve-en-1448.webp",
  "size": 88554,
  "content_type": "image/webp",
  "created_at": "2026-09-26T22:45:43Z"
}
